import { Routes } from "@angular/router";
import { RentVsBuyComponent } from "./rent-vs-buy.component";
import { provideEffects } from "@ngrx/effects";
import { RentVsBuyEffects } from "./effects/rent-vs-buy.effect";

export const rentVsBuyToolRoutes: Routes = [
    {
        path: "",
        component: RentVsBuyComponent,
        providers: [provideEffects(RentVsBuyEffects)],
    },
];
